import React from "react";
import { Checkbox } from "antd";
import styles from "./agreementCheckbox.scss";

const AgreementCheckbox = ({ isChecked, onChange, name, children }) => (
  <Checkbox
    checked={isChecked}
    onChange={onChange}
    name={name}
    className={styles.label}
  >
    <span className={styles.text}>{children}</span>
  </Checkbox>
);

export default AgreementCheckbox;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/AgreementSection/AgreementCheckbox/index.tsx